/*---------------函数拓展方法---------------*/
/*
 * 页面被iframe加载时 iframe页面触发遮罩层时 加载页面同时也触发 遮罩
 * */
var AJAXMSGFLAG = true;
(function ($) {
    //首先备份下jquery的ajax方法
    var _ajax = $.ajax;
    var timer = null;
    var delay = 3 * 1000;
    var contentType = "application/x-www-form-urlencoded; charset=utf-8";
    //重写jquery的ajax方法
    $.ajax = function (opt) {
        var token = $.cookie('token');
        //备份opt中error和success方法
        var fn = {
            beforeSend: function () {
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
            },
            success: function (data, textStatus) {

            },
            complete: function () {
            }
        }
        if (opt.error) {
            fn.error = opt.error;
        }
        if (opt.success) {
            fn.success = opt.success;
        }
        if (opt.complete) {
            fn.complete = opt.complete;
        }
        if (opt.beforeSend) {
            fn.beforeSend = opt.beforeSend;
        }
        var isJqGridList = false;
        if (hasValue(opt.data) && hasValue(opt.data.rows)) {
            isJqGridList = true;
            opt.type = 'POST';
            //假如java需要的json数据多了一层结构，则走入此判断将json结构改为java层需要的数据结构
            if (hasValue(opt.data.modelChange)) {
                var modelValData = {};
                for (var i in opt.data) {
                    if (i !== 'modelChange' && i !== 'modelKey') {
                        modelValData[i] = opt.data[i];
                    }
                }
                var newData = {};
                newData[opt.data.modelKey] = JSON.stringify(modelValData);
                opt.data = newData;
            }
        }
        //当ajax参数中contentTypeNoChange为true时，contentType配置保持调用地方的设置
        if (!hasValue(opt.contentTypeNoChange) && !isJqGridList) {
            if (opt.contentType !== false) {
                opt.contentType = contentType;
            }
            if (opt.data && isJSONStr(opt.data)) {
                opt.data = JSON.parse(opt.data);
            }
        }
        //扩展增强处理
        var _opt = $.extend(opt, {
            headers: {
                'token': token
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                //错误方法增强处理
                fn.error(XMLHttpRequest, textStatus, errorThrown);
            },
            success: function (data, textStatus, XHR) {
                if (!!data && isJSONStr(data)) {
                    data = JSON.parse(data);
                }
                if ((!!data) && !data.success && data.msg == '操作会话已过期，请重新登录！') {
                    alertfuncV2("提醒", "登陆已过期", function () {
                        window.location.href = "/public_build/views/render.html"
                    })
                } else {
                    //成功回调方法增强处理
                    fn.success(data, textStatus);
                }
            },

            beforeSend: function (xhr, o) {
                var sendUrl = o.url
                var filterUrlFlag = sendUrl.indexOf(setDomain("manage", "message/updateMessageRead.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "sso/getVerifyCode.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "user/updPwd.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "sso/loginByVerifyCode.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "sso/loginBySource.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "sso/login.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "message/queryMymessage.do")) === -1
                    && sendUrl.indexOf(setDomain("manage", "message/selectMymessage.do")) === -1;
                if (AJAXMSGFLAG && filterUrlFlag) {
                    AJAXMSGFLAG = false
                    pushMymessage()
                }
                xhr.setRequestHeader("token", token);
                fn.beforeSend();
            },
            complete: function () {
                //请求完成后回调函数 (请求成功或失败之后均调用)。
                fn.complete();
            }
        });
        let newUrl = _opt.url;
        if (newUrl.indexOf('.html') != -1) {
            let env = getLocalStorage("envParam");
            let veron = new Date().getTime();
            if (hasValue(env) && hasValue(env.ENV)) {
                veron = env.ENV;
            }
            if (newUrl.indexOf('?') == -1) {
                newUrl = newUrl + '?version=' + veron;
            } else if (newUrl.indexOf('version') == -1) {
                newUrl = newUrl + '&version=' + veron;
            }
        }
        _opt.url = newUrl
        return _ajax(_opt);
    };
    $.fn.showModalAll = function () {
        $(this).show(5);
        modalForParent('show');
    }
    $.fn.showModalAllV2 = function () {
        $(this).show(5);
        modalForParent('showV2');
    }
    $.fn.hideModalAllV2 = function () {
        $(this).hide();
        modalForParent('hideV2');
    }
    $.fn.hideModalAll = function () {
        $(this).hide();
        modalForParent('hide');
    }


    createWebSocket();

    /**
     * websocket启动
     */
    function createWebSocket() {
        try {
            if ('WebSocket' in window) {
                var webSocketUrl = setDomain("manage", "websocket") + "/";
                if (webSocketUrl.indexOf("http") != -1) {
                    webSocketUrl = webSocketUrl.replace("http", "ws")
                } else {
                    webSocketUrl = webSocketUrl.replace("https", "wss")
                }
                // var webSocketUrl = "ws://127.0.0.1:8088/ucp.manage.vc/websocket/";
                //实现化WebSocket对象
                websocket = new WebSocket(webSocketUrl + sessionUser.userId);
            } else {
                alert('【WebSocket】:该浏览器不支持websocket')
            }
            init();
        } catch (e) {
            console.log('catch' + e);
            reconnect();
        }

    }

    function init() {
        //连接成功建立的回调方法
        websocket.onopen = function (event) {
            console.log("【WebSocket】:已连接");
            //心跳检测重置
            heartCheck.reset().start();
        };

        //接收到消息的回调方法
        websocket.onmessage = function (event) {
            //心跳机制检测
            if ("pang" == event.data) {
                heartCheck.reset().start();
                return;
            }
            //若不是心跳检测，则跳转到相应方法，所有的业务方法均在此处写，写好备注！
            var data = JSON.parse(event.data)
            if (hasValue(data.webSocketGetWay)) {
                switch (data.webSocketGetWay) {
                    case 1://系统消息通知
                        if(!data.vc2MessageContent.includes('_APPOINTMENT_MESSAGE')){
                            msgTip(data);
                        }
                        heartCheck.reset().start();
                        break;
                    default:
                        console.log("【WebSocket】:暂未找到相应路由！");
                }
            }
        };

        //连接发生错误的回调方法
        websocket.onerror = function (event) {
            console.log("【WebSocket】:发生错误");
            reconnect();
        };

        //连接关闭的回调方法
        websocket.onclose = function (event) {
            heartCheck.reset();//心跳检测
            reconnect();
        };

        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = function () {
            websocket.close();
        };

        //关闭连接
        function closeWebSocket() {
            websocket.close();
        }

        //发送消息
        function send(message) {
            websocket.send(message);
        }
    }

    //避免重复连接
    var lockReconnect = false, tt;

    /**
     * websocket重连
     */
    function reconnect() {
        if (lockReconnect) {
            return;
        }
        lockReconnect = true;
        tt && clearTimeout(tt);
        tt = setTimeout(function () {
            console.log('【WebSocket】:重连中...');
            lockReconnect = false;
            createWebSocket();
        }, 4000);
    }

    /**
     * websocket心跳检测
     */
    var heartCheck = {
        timeout: 5000,
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function () {
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            return this;
        },
        start: function () {
            var self = this;
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(function () {
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                //onmessage拿到返回的心跳就说明连接正常
                websocket.send("HeartBeat");
                self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
                    console.log('【WebSocket】:关闭服务');
                    websocket.close();//如果onclose会执行reconnect，我们执行 websocket.close()就行了.如果直接执行 reconnect 会触发onclose导致重连两次
                }, self.timeout)
            }, this.timeout)
        }
    };
})(jQuery);


setInterval(function () {
    AJAXMSGFLAG = true
}, 10 * 1000);

//判断是否是json格式的字符串
function isJSONStr(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    } else {
        return false;
    }
}

/**
 * 根据token查找用户信息
 * @returns
 */
function checkSession(token, callback) {
    if (token) {
        $.cookie('token', token, {
            expires: 7,
            path: '/'
        });
        $.ajax({
            url: setDomain("manage", "sso/check.do"),
            type: "post",
            async: true,
            dataType: "json",
            success: function (data) {
                callback(data);
            }, error: function (e) {
                callback(false);
            }
        });
    } else {
        callback(false);
    }
}


// 获取我的消息
function pushMymessage() {
    var hash = window.location.hash
    var htmlFalg = hash.indexOf("my-message/detail") === -1 && hash.indexOf("setting/my-message")
    if (htmlFalg) {
        doAjax({
            url: setDomain("manage", "message/pushMymessage.do"),
            loading: true
        }).done(function (res) {
            if (res.success) {
                if (res.queryPushMessage.length > 0) {
                    handleMssageHtml(res.queryPushMessage)
                }
            }
        })
    }
}

function getEnvParam() {
    $.ajax({
        url: setDomain("base", "env/getEnvParam.do"),
        type: "post",
        async: false,
        data: {"urlName": window.location.host},
        success: function (res) {
            if (res.code == 10000) {
                var resJson = res.responseBody.resJson;
                window.localStorage.setItem("envParam", JSON.stringify(resJson));
            }
        },
    });
}

/*
*设置请求路径
* */
function setDomain(str, url) {
    var domainIp = window.location.origin;   //服务器环境
    if (!!str && !!url) {
        return domainIp + "/ucp." + str + ".vc/" + url;
    } else {
        console.log('setDomain的参数输入不正确');
        return '';
    }
}

function getUrl(url) {
    return url;
}

function handleMssageHtml(list) {
    var html = '<div class="djax-modal" style="display: block">' +
        '<div class="djax-wrapper" style="width: 800px">' +
        '<div class="djax-title">消息通知</div> ' +
        '<div class="djax-content clearfix" style="max-height: 400px;">' +
        '<p class="msg-title center bolder"></p>' +
        '<textarea class="msg-content" readonly="readonly" style="resize: none;width: 100%;min-height:150px;max-height:264px;border: 0"></textarea>' +
        '   </div>' +
        '   <div class="djax-footer">' +
        '   <button class="djax-btn-ok prev" style="display: none">上一页</button>' +
        '   <button class="djax-btn-ok next" style="display: none">下一页</button>' +
        '   <button class="djax-btn-ok ok" style="display: none">确定</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    var $html = $(html);
    $html.on("click", ".ok", function (e) {
        $html.remove();
        offClick();
    });
    var $next = $html.find(".next")
    var $prev = $html.find(".prev")
    var $ok = $html.find(".ok")
    var $content = $html.find(".msg-content")
    var $title = $html.find(".msg-title")

    var listLength = list.length
    if (listLength > 1) {
        $next.show()
    }
    if (listLength == 1) {
        $ok.show()
    }

    var msgIndex = 0
    $html.find(".msg-title").html(list[0].VC2_MESSAGE_TITLE)
    $html.find(".msg-content").html(list[0].VC2_MESSAGE_CONTENT)

    $html.on("click", ".prev", function (e) {
        if (msgIndex >= 1) {
            msgIndex--;
            $next.show()
            if (msgIndex == 0) {
                $prev.hide()
            }
            if (msgIndex == listLength - 2) {
                $ok.hide()
            }
            $title.html(list[msgIndex].VC2_MESSAGE_TITLE)
            $content.html(list[msgIndex].VC2_MESSAGE_CONTENT)
        }
    });

    $html.on("click", ".next", function (e) {
        if (msgIndex < listLength - 1) {
            msgIndex++;
            $prev.show()
            if (msgIndex == listLength - 1) {
                $next.hide()
                $ok.show()
            }
            $title.html(list[msgIndex].VC2_MESSAGE_TITLE)
            $content.html(list[msgIndex].VC2_MESSAGE_CONTENT)
            if (!list[msgIndex].readed) {
                doAjax({
                    url: setDomain("manage", "message/updateMessageRead.do"),
                    params: {numMessageId: list[msgIndex].NUM_MESSAGE_ID},
                    loading: true
                }).done(function (res) {
                    if (res.success) {
                        list[msgIndex].readed = true
                    }
                })
            }
        }
    });

    function offClick() {
        $html.off("click", ".ok");
    }

    $('body').append($html)
}


/*
 * 数组求差集
 * */
var arrayIntersect = function (a, b) {
    return $.merge($.grep(a, function (i) {
            return $.inArray(i, b) == -1;

        }), $.grep(b, function (i) {
            return $.inArray(i, a) == -1;
        })
    );
};
/*
 * 对象相等
 * */
Array.prototype.contains = function (obj) {
    var i = this.length;
    while (i--) {
        if (this[i] === obj) {
            return true;
        }
    }
    return false;
};

function contains(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === val) {
            return true;
        }
    }
    return false;
}

/*
* 通知iframe弹层
* */
function modalForParent(flag) {
    if (flag == 'show') {
        window.parent.postMessage({"type": 1, "oper": "show"}, '*');
    }
    if (flag == 'hide') {
        window.parent.postMessage({"type": 1, "oper": "hide"}, '*');
    }
    if (flag == 'showV2') {
        window.parent.postMessage({"type": 1, "oper": "showV2"}, '*');
    }
    if (flag == 'hideV2') {
        window.parent.postMessage({"type": 1, "oper": "hideV2"}, '*');
    }
}

/*
 alert方法 覆盖系统方法  添加外部页面引用本页面 遮罩层的控制
 */
function alert(info) {
    bootbox.alert({
        buttons: {
            ok: {
                label: '确认',
                className: 'btn-alert'
            }
        },
        message: info,
        callback: function (result) {
            modalForParent('hide')
        },
        title: "提示信息",
    });
    modalForParent('show')
}

function alertV2(info) {
    bootbox.alert({
        buttons: {
            ok: {
                label: '确认',
                className: 'btn-alert'
            }
        },
        message: info,
        callback: function (result) {
            modalForParent('hideV2')
        },
        title: "提示信息",
    });
    modalForParent('showV2')
}

function alertfunc(title, message, callback) {
    if (title == '') {
        title = "提示信息"
    }
    bootbox.alert({
        buttons: {
            ok: {
                label: '确认',
                className: 'btn-alert'
            }
        },
        message: message,
        callback: function (result) {
            callback(result)
            modalForParent('hide')
        },
        title: title,
    });
    modalForParent('show')
}

function alertfuncV2(title, message, callback) {
    bootbox.alert({
        buttons: {
            ok: {
                label: '确认',
                className: 'btn-alert'
            }
        },
        message: message,
        callback: function (result) {
            callback(result)
            modalForParent('hideV2')
        },
        title: "提示信息",
    });
    modalForParent('showV2')
}

function confirm(title, message, callback) {
    bootbox.confirm({
        title: title,
        message: message,
        callback: function (result) {
            callback(result);
            modalForParent('hide')
        }
    });
    modalForParent('show')
}

function confirmV2(title, message, callback) {
    bootbox.confirm({
        title: title,
        message: message,
        callback: function (result) {
            callback(result);
            modalForParent('hideV2')
        }
    });
    modalForParent('showV2')
}


function ucpTip(msg) {
    html = '<div class="ucpTip" style="position: fixed;top:48%;left:50%;z-index:10000;min-height:72px;max-width: 200px;background: #f2dede">' +
        '<div class="close" onclick="ucpTipClose(this)" style="position: absolute;top: 0px; right: 10px; height: 20px;"><icon class="ace-icon glyphicon glyphicon-remove blank" style="font-size: 12px;"></icon></div>' +
        '<p style="margin-top: 20px;font-size: 12px;padding: 10px;color: #a94442">' + msg + '</p>'
    '</div>';
    $('body').append(html);
    setTimeout(function () {
        $(".ucpTip").fadeOut(1000, function () {
            $(".ucpTip").remove();
        });
    }, 2000)
}

function ucpTipClose(obj) {
    $(obj).parents(".ucpTip").remove()
}

/*---------------枚举方法---------------*/
function carType(n) {
    var result = ""
    var n = parseInt(n);
    if (n == 1) {
        result = "家庭自用车"
    }
    if (n == 2) {
        result = "党政机关、事业团体"
    }
    if (n == 3) {
        result = "非营业企业客车"
    }
    if (n == 4) {
        result = "营业货车"
    }
    if (n == 5) {
        result = "非营业货车"
    }
    return result;
}

function carOperat(n) {
    var result = ""
    var n = parseInt(n);
    if (n == "01") {
        result = "大型汽车号牌"
    }
    if (n == "02") {
        result = "小型汽车号牌"
    }
    if (n == "52") {
        result = "小型新能源汽车"
    }
    return result;
}

function company(n) {
    let result
    result = getLocalStorage("insurcompanyAll").filter(s =>String(s.numInsurcompanyid) === String(n)).map(s =>{
        return s.vc2Insurcompanyshortname
    });
    if (!hasValue(result)){
        result = "暂无"
    }
    return result;
}

function getState(State) {
    var result = ""
    if (State == 1) {
        result = "询价中"
    } else if (State == 2) {
        result = "询价失败"
    } else if (State == 3) {
        result = "询价成功"
    } else if (State == 4) {
        result = "转人工询价"
    } else if (State == 5) {
        result = "询价取消"
    } else if (State == 6) {
        result = "无法询价"
    } else if (State == 7) {
        result = "重复报价"
    }
    return result;
}

function getCompanyQuotationResultStatus(v) {
    var result = "";
    v = parseInt(v);
    switch (v) {
        case 0:
            result = "询价中";
            break;
        case 1:
            result = "询价成功";
            break;
        case 2:
            result = "询价失败";
            break;
        case 3:
            result = "询价成功";
            break;
        case 4:
            result = "转人工询价";
            break;
        case 5:
            result = "无法询价";
            break;
        case 6:
            result = "询价取消";
            break;
        case 7:
            result = "重复投保";
            break;
    }
    return result;
}

function invoiceType(n) {
    var result = "";
    if (n == 0) {
        result = "不开发票"
    }
    if (n == 1) {
        result = "普通发票"
    }
    if (n == 2) {
        result = "专用发票"
    }
    if (n == 3) {
        result = "电子发票"
    }
    return result;
}

/*---------------系统使用方法---------------*/

/*
 * 获取URL参数  仅限ace框架
 *
 * */
function getQueryParam(name) {
    var url = window.location.href;
    if (url.indexOf('?') != -1) {
        var paramString = url.split("?")[1].split("#page")[0];
    } else {
        return null;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = paramString.match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    }
    return null;
}

/*输入验证 数字*/
function replacAmt(obj) {
    //先把非数字的都替换掉，除了数字和.
    obj.value = obj.value.replace(/[^\d.]/g, "");
    //必须保证第一个为数字而不是.
    obj.value = obj.value.replace(/^\./g, "");
    //保证只有出现一个.而没有多个.
    obj.value = obj.value.replace(/\.{2,}/g, ".");
    //保证.只出现一次，而不能出现两次以上
    obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
}

function checkDate(v) {
    var a = /^(\d{4})-(\d{2})-(\d{2})$/
    if (!a.test(v)) {
        return false
    } else {
        return (moment(v).format("DD") == v.substring(v.length - 2));
    }
}

/*
* 判断是否有特殊字符
* */
function hasSpecialCharacter(text) {
    var regEn = /[`~!@#$%^&*_+<>?:"{},\/;'[\]]/im,
        regCn = /[··！#￥——：；“”‘、，|《。》？、【】[\]]/im;
    if (regEn.test(text) || regCn.test(text)) {
        return true;
    } else {
        return false;
    }
}

/*
* 判断是否有特殊字符 适用于品牌型号 不含有+
* */
function hasSpecialCharacterVc2Brand(text) {
    let regEn = /[`~!@#$%^&*_<>?:"{},\/;'[\]]/im,
        regCn = /[··！#￥——：；“”‘、，|《。》？、【】[\]]/im;
    if (regEn.test(text) || regCn.test(text)) {
        return true;
    } else {
        return false;
    }
}

/*
* 判断是否有星号
* */
function hasAsterisk(v) {
    if (v.indexOf("*") == -1) {
        return false
    } else {
        return true
    }
}

/*
* 判断是否为空
* */
function isNUll(v) {
    if (v == undefined) {
        return true
    } else if (v === "" || v === null) {
        return true
    } else if (v.length == 0) {
        return true
    } else {
        return false
    }
}


function dateTimeToString(date) {
    if (date == "Invalid Date") {
        return "";
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    return y + '-' + (m < 10 ? ('0' + m) : m) + '-'
        + (d < 10 ? ('0' + d) : d) + ' ' + (h < 10 ? ('0' + h) : h)
        + ':' + (mi < 10 ? ('0' + mi) : mi) + ':'
        + (s < 10 ? ('0' + s) : s);
}

/**
 * 小数转换为百分比
 * @param data
 * @returns {string}
 */
function toPercentComm(data) {
    var ret = "0%";
    if (data) {
        var num = 6;
        //截取，查看需要保留几位小数
        try {
            var array = data.toString().split(".");
            num = (array[1].length - 2)
            if (num < 0) {
                num = 0;//不需要
            }
        } catch (e) {
            console.log(JSON.stringify(e));
        }
        //查看需要保留几位
        var strData = parseFloat(data) * 100;
        strData = strData.toFixed(num);
        ret = strData.toString() + "%";
    }
    return ret;
}

/**
 * 转换为小数
 * @param percent
 * @returns {number}
 */
function toPointComm(percent) {
    var str = 0;
    if (percent) {
        str = (percent / 100).toFixed(6);
    }
    return str;
}

/**
 * 小数转换为数字
 * @param percent
 * @returns {number}
 */
function toNumComm(percent) {
    var r = 0;
    if (percent) {
        var num = 6;
        //截取，查看需要保留几位小数
        try {
            var array = percent.toString().split(".");
            num = (array[1].length - 2)
            if (num < 0) {
                num = 0;//不需要
            }
        } catch (e) {
            console.log(JSON.stringify(e));
        }
        //r = Math.round((percent * 100)).toFixed(num);
        r = (percent * 100).toFixed(num);
    }
    return r;
}

/*
* 验证身份证证号合法性（有逻辑规则）
* */
function validateIdCardNo(value) {
    function checkDate(ID) {
        var year, month, day, tempDate;
        var length18Or15 = ID.length
        if (length18Or15 === 18) {
            year = ID.substring(6, 10)
            month = ID.substring(10, 12)
            day = ID.substring(12, 14)
            // with parseInt, 05 will be 5
            tempDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
            return !(tempDate.getFullYear() !== parseInt(year) || tempDate.getMonth() !== parseInt(month) - 1 || tempDate.getDate() !== parseInt(day))
        } else if (length18Or15 === 15) {
            year = ID.substring(6, 8)
            month = ID.substring(8, 10)
            day = ID.substring(10, 12)
            // with parseInt, 05 will be 5
            tempDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
            // .getYear() is not recommended for use any longer,
            // so here getFullYear() is used although it may seem not simple enough
            return !(('' + tempDate.getFullYear()).substring(2) !== parseInt(year) || tempDate.getMonth() !== parseInt(month) - 1 || tempDate.getDate() !== parseInt(day))
        } else {
            console.log('Unknown error!')
            // return
        }
    }

    var ID = '' + value
    if (/^[1-9][0-9]{16}([0-9]|[xX])$/.test(ID)) {
        if (checkDate(ID)) {
            // turn ID to an array
            var arrID = ID.split('')
            // factors for 1st-17st ID digits
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]
            // the check code for the 18th digit in the ID number
            var checkCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]
            var sum = 0
            // if the 18th digit is the letter X (or x), change it to be the digit 10
            if (arrID[17].toLowerCase() === 'x') {
                arrID[17] = 10
            }
            // multiply first 17 ID digits by corresponding factor elements, and sum these results
            for (var i = 16; i >= 0; i--) {
                sum += arrID[i] * factor[i]
            }
            // let remainder = sum % 11
            return parseInt(arrID[17]) === checkCode[sum % 11]
        }
        return false
    } else if (/^[1-9][0-9]{14}$/.test(ID)) {
        return checkDate(ID)
    } else {
        return false
    }
}

/*
* 验证公司名字是否有特殊字符
* */
function validateCompanyName(text) {
    var regEn = /[`~!@#$%^&*_+<>?:"{},.\/;'[\]]/im,
        regCn = /[··！#￥——：；“”‘、，|《。》？、【】[\]]/im;
    if (regEn.test(text) || regCn.test(text)) {
        return false;
    } else {
        return true;
    }
}

function checkPhone(phone) {
    var istel = /^0\d{2,3}\d{7,8}$/;
    var isMob = /^1[3|4|5|6|7|8|9][0-9]{9}$/
    if (istel.test(phone) || isMob.test(phone)) {
        return true;
    } else {
        return false;
    }
}

/*
* 判断是否为数字
* */
function isNumber(v) {
    var reg = /^[0-9]\d*$/;
    if (reg.test(v)) {
        return true;
    } else {
        return false;
    }
}

function isNumber2(val) {
    if (parseFloat(val).toString() == "NaN") {
        return false;
    } else {
        return true;
    }
}

/*
* 验证日期格式  YYYY-MM-DD HH:mm
* */
function checkDatetime(date) {
    if (date.length != 16) {
        return false;
    }
    var v = moment(date).format('YYYY-MM-DD HH:mm');
    if (v == "Invalid date") {
        return false;
    }
    return true;
}

/**
 * json对象转字符串形式
 */
function json2str(o) {
    var arr = [];
    var fmt = function (s) {
        if (typeof s == 'object' && s != null) {
            return json2str(s);
        }
        return /^(string|number)$/.test(typeof s) ? "'" + s + "'" : s;
    }
    for (var i in o) arr.push("'" + i + "':" + fmt(o[i]));
    return '{' + arr.join(',') + '}';
}


function setLocalStorage(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
}

function getLocalStorage(key) {
    var result = "";
    if (localStorage.getItem(key) != null) {
        return JSON.parse(localStorage.getItem(key));
    } else {
        return result;
    }
}

function clearNoNum(obj) {
    obj.value = obj.value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
    obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
    if (obj.value.indexOf(".") < 0 && obj.value != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj.value = parseFloat(obj.value);
    }
}

function typeOf(input) {
    return ({}).toString.call(input).slice(8, -1).toLowerCase()
}

// 合并对象属性（在原始对象上进行修改）
function merge(obj, options) {
    if (obj && options) {
        for (var p in options) {
            if (typeOf(obj[p]) === 'object' && typeOf(options[p]) === 'object') {
                merge(obj[p], options[p])
            } else {
                obj[p] = options[p]
            }
        }
    }
    return obj
}


/*
* 封装ajax
* */
function doAjax(obj) {
    obj = merge({url: "", params: {}, type: '', async: true, loading: false, config: {type: ''}}, obj)
    var method = obj.type || "POST";
    var token = sessionStorage.getItem("originalToken");
    return $.ajax({
        url: obj.url,
        type: method,
        async: obj.async,
        data: obj.params,
        dataType: 'json',
        contentType: obj.config.type == 'JSON' ? "application/json;charset=utf-8" : "application/x-www-form-urlencoded;charset=utf-8",
        headers: {
            'token': token
        }
    });
}


function getFeeStyle(n) {
    var result;
    switch (n) {
        case 1:
            result = "支付宝"
            break;
        case 2:
            result = "微信"
            break;
        case 3:
            result = "预付款"
            break;
        case 4:
            result = "转账"
            break;
        case 5:
            result = "现金"
            break;
        case 6:
            result = "支票"
            break;
        case 7:
            result = "个人"
            break;
        case 8:
            result = "贷记"
            break;
        case 9:
            result = "POS"
            break;
        case 10:
            result = "快钱POS"
            break;
        case 11:
            result = "全支付"
            break;
        case 12:
            result = "垫付"
            break;

        default:
            result = "暂无"
    }
    return result;
}

/*计算推送来源*/
function computePushPoint(v) {
    var result = ""
    if (v == 1) {
        result = "微信"
    } else if (v == 2) {
        result = "中台"
    }
    return result;
}

/*计算推送状态*/
function computePushStatus(v) {
    var result = ""
    if (v == 0) {
        result = "失败"
    } else if (v == 1) {
        result = "成功"
    }
    return result;
}

/**
 *
 * 车牌号验证    普通车牌+新能源
 */
function verifyLicensePlateNum(value) {
    const express = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]?[0-9a-zA-Z]{6,7}$/
    const result = express.test(value);
    return result;
}


//下载ajax请求回来的文件流blob
function downloadAjaxBlob({url, params, filetype, filename, method}) {
    utils.wait(true);
    //判断如果是音频下载并且域名协议跟资源协议不一致时，替换资源路径的协议
    if (!!filetype && (filetype == '.wav' || filetype == '.mp3')) {
        var originUrl = window.location.origin;
        if (originUrl.indexOf("https://") > -1 && url.indexOf("http://") > -1) {
            url = url.replace(/http:\/\//, "https://");
        }
        if (originUrl.indexOf("http://") > -1 && url.indexOf("https://") > -1) {
            url = url.replace(/https:\/\//, "http://");
        }
    }
    params = (function () {
        var arr = Object.keys(params);
        var text = '';
        arr.forEach(function (key) {
            text += key + '=' + params[key] + '&';
        });
        text.replace(/&$/, '');
        return text;
    })();
    var ajaxMethod = method || "POST";
    var xhr = new XMLHttpRequest();  //定义http请求对象
    xhr.open(ajaxMethod, url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
    xhr.setRequestHeader("token", $.cookie('token'));
    xhr.send(params);
    xhr.responseType = "blob";  // 返回类型blob
    xhr.onload = function () {   // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
        utils.wait(false);
        if (this.status === 200) {
            var blob = this.response;
            if (blob.size === 0) {
                alert('此文件大小为0，因此不能下载！');
                return false;
            }
            var reader = new FileReader();
            reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
            reader.onload = function (e) {
                console.log(e);         //查看有没有接收到数据流
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a');
                var nowDate = new Date().getTime();
                var fileName = filename || nowDate;
                var fileType = filetype || ".xls";
                a.download = fileName + fileType;       //自定义下载文件名称
                a.href = e.target.result;
                $("body").append(a);    // 修复firefox中无法触发click
                a.click();
                $(a).remove();
            }
        } else {
            console.log('出现了未知的错误!');
            alert("下载错误，请联系管理员")
        }
    }
}

/*
记录操作日志
操作模块 ，用户：1；配置：2；财务：3；订单：5；
var vc2Module = "1";
操作对象
var vc2Object = "1";
操作类型 添加：1；修改：2；删除：3。
var numType = "";
操作描述
var vc2Detail = "";
操作对象id
numObjectId
回调函数
callback
*/
function addOperationLog({
                             vc2Module = "",
                             vc2Object = "",
                             numObjectId = "",
                             numType = "",
                             vc2Detail = "",
                             vc2DetailClob = "",
                             callback
                         }) {
    var sessionUser = localStorage.getItem('sessionUser');
    if (!hasValue(sessionUser)) {
        console.log('缺少用户信息，记录操作日志失败');
        return false;
    }
    var numUserid = JSON.parse(sessionUser).userId;
    if (!hasValue(numUserid)) {
        console.log('缺少用户id，记录操作日志失败');
        return false;
    }
    if (!hasValue(vc2Module) || !hasValue(vc2Object) || !hasValue(numObjectId) || !hasValue(numType)) {
        console.log('缺少必填参数，记录操作日志失败');
        return false;
    }
    var params = {
        numUserid: numUserid,
        vc2Module: vc2Module,
        vc2Object: vc2Object,
        numObjectId: numObjectId,
        numType: numType
    };
    if (hasValue(vc2Detail)) {
        params.vc2Detail = vc2Detail;
    }
    if (hasValue(vc2DetailClob)) {
        params.vc2DetailClob = vc2DetailClob;
    }
    $.ajax({
        url: setDomain("base", "operation/addOperationlog.do"),
        type: "post",
        dataType: "json",
        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
        data: params,
        success: function (res) {
            if (res.success) {
                console.log('添加日志成功!');
            } else {
                console.log('添加日志失败!');
            }
            if (hasValue(callback)) {
                callback(res);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alertV2("请求时出错,请检查输入,错误码:" + XMLHttpRequest.status);
        }
    })
}


/**
 * 获取智能外呼列表
 * @param param
 */
function queryAiBotCCTaskList(param = {}) {
    return new Promise((resolve => {
        $.ajax({
            url: setDomain("callcenter", "aiBotCCTask/queryAiBotCCTaskList.do"),
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(param),
            contentTypeNoChange: true,
            success: function (data) {
                resolve(data)
            }
        })
    }))
}

//下载音频文件
function downloadFile(downloadUrl) {
    var param = {};
    param.recordingUrl = downloadUrl;
    var url = setDomain("callcenter", "callCenter/downloadRecording.do");
    if (downloadUrl.indexOf(".wav", 0) != -1) {
        downloadAjaxBlob({
            url: url,
            params: param,
            filetype: ".wav"
        })
    }
    if (downloadUrl.indexOf(".mp3", 0) != -1) {
        downloadAjaxBlob({
            url: url,
            params: param,
            filetype: ".mp3"
        })
    }
}


//下载txt文件
window.downloadTxtFile = function (downloadUrl) {
    let xhr = new XMLHttpRequest();//创建 XMLHttpRequest 对象
    xhr.open('get', downloadUrl, true);//规定请求的类型、URL 以及是否异步处理请求。三个参数分别是 method：请求的类型；GET 或 POST url：文件在服务器上的位置 async：true（异步）或 false（同步）
    xhr.setRequestHeader('Content-Type', 'application/txt');//设置请求头
    xhr.responseType = "blob";//返回的数据类型 这儿需要blob对象
    xhr.onload = function () {//请求成功回调函数
        if (this.status == 200) {
            var blob = this.response;
        }
    }
    xhr.send();
}


//根据选中的部门渲染用户
function selectUserBydeptId(pdom, cdom, flag) {
    var deptId = $(pdom).val();
    doAjax({
        url: setDomain("callcenter", "callCenter/selectUserBydeptId.do"),
        params: {deptId: deptId},
        loading: true
    }).done(function (data) {
        if (data.success) {
            var html = "";
            if (!flag) {
                html += "<option value='0'>请选择</option>";
            }
            $.each(data.userList, function (i, value) {
                html += '<option value="' + value.USER_ID + '">' + value.USER_NICKNAME + '</option>';
            });
            $(cdom).html(html);
            $(cdom).multiselect("rebuild");
        }
    })
}

/**
 * 系统消息接收
 * @param event
 */
function msgTip(event) {
    // $(".ui-content").show()
    // $("#msgggg").click
    var list = [{
        "VC2_MESSAGE_TITLE": event.vc2MessageTitle,
        "VC2_MESSAGE_CONTENT": event.vc2MessageContent
    }]
    handleMssageHtml(list)
}

function setDatBizEnd(startId, endId, checkedFulg) {
    var datBizEnd = ""
    if (hasValue($(startId).val())) {
        if (hasValue(checkedFulg) && checkedFulg) {
            //如果选中是否延期，则默认为一年减一个月
            datBizEnd = moment($(startId).val()).add('year', 1).subtract(1, 'months').format("YYYY-MM-DD 00:00");
        } else {
            datBizEnd = moment($(startId).val()).add('year', 1).format("YYYY-MM-DD 00:00");
        }
    }
    $(endId).val(datBizEnd);
}

function setDatTrafficEnd(startId, endId) {
    var datTrafficEnd = ""
    if (hasValue($(startId).val())) {
        if ($(startId).val().indexOf("00:00") >= 0) {
            datTrafficEnd = moment($(startId).val()).add('year', 1).format("YYYY-MM-DD HH:mm");
        } else {
            datTrafficEnd = moment($(startId).val()).add('year', 1).format("YYYY-MM-DD HH:mm");
        }
    }
    $(endId).val(datTrafficEnd);
}

/**
 * 数据脱敏处理
 * @param type 数据类型
 * 1 姓名 2 手机号 3 证件号 4 地址
 * @param data 脱敏数据
 */
function encryptData(type, data) {
    if (hasValue(data)) {
        if (type == 1) {//姓名脱敏
            if (data.length <= 3) {
                return data.substring(0, 1) + "*" + data.substring(2, data.length);
            } else if (data.length > 3 && data.length <= 6) {
                return "**" + data.substring(2, data.length);
            } else if (data.length > 6) {
                return data.substring(0, 2) + "****" + data.substring(6, data.length)
            }
        } else if (type == 2) {//手机号脱敏
            var pat = /(\d{3})\d*(\d{4})/;
            return data.replace(pat, '$1****$2');
        } else if (type == 3) {//证件号脱敏
            if (data.length == 18) {
                // var pat = /(\d{4})\d*(\d{4})/;
                // return data.replace(pat, '$1***********$2');
                return data.substring(0, 4) + "***********" + data.substring(14, data.length);
            } else {
                return data.substring(0, 3) + "****" + data.substring(7, data.length);
            }
        } else if (type == 4) {//地址脱敏
            return "**" + data.substring(2, data.length);
        }
    } else {
        return "";
    }
}

/**
 * 获取城市名称
 * @param ciytCode
 * @returns {*}
 */
function getCityName(ciytCode) {
    let cityCodeStr = localStorage.getItem("quoteCityCode")
    let cityCodeJson = JSON.parse(cityCodeStr);
    var city = "";
    if (hasValue(cityCodeJson)) {
        $.each(cityCodeJson, function (key, val) {
            if (val.NUM_CITY_ENUM == ciytCode) {
                city = val.VC2_CITY_NAME;
            }
        })
    } else {
        city = ciytCode;
    }
    return city
}


/**
 * 保司账号动态添加dom
 * @param parse 配置的dom结构
 * @param isDefault 是否添加默认值
 * @param defaultInfo 默认值数据
 * @param addOldDomId 添加的父节点id
 */
function addCompanyDom(parse, isDefault, defaultInfo, addOldDomId){
    var html = '';
    //input输入框
    var insConfigInfoInput = parse.input;
    for (let i = 0; i < insConfigInfoInput.length; i++) {
        var insConfigInfoInputElement = insConfigInfoInput[i];
        var sectionRoleId = insConfigInfoInputElement.ins + "_" + insConfigInfoInputElement.id;
        var infoId = insConfigInfoInputElement.id + "-" + insConfigInfoInputElement.ins;
        html += '<section class="row" id="' + sectionRoleId + '" style="display: none">' +
            '<span class="title">' + insConfigInfoInputElement.title + '</span>' +
            '<input id="' + infoId + '" type="text" class="field field-text" maxlength="100">';
        if (insConfigInfoInputElement.isTips) {
            html += '<span class="help-icon">?</span>' +
                '<div class="help-tooltip">' +
                '<span>' + insConfigInfoInputElement.tipsText + '</span>';
            if (hasValue(insConfigInfoInputElement.tipsImg)) {
                html += '<img src="' + insConfigInfoInputElement.tipsImg + '">';
            }
            html += '</div>';
        }
        html += '</section>';
    }
    //select输入框
    var insConfigInfoSelect = parse.select;
    for (let i = 0; i < insConfigInfoSelect.length; i++) {
        var insConfigInfoSelectElement = insConfigInfoSelect[i];
        var sectionRoleId = insConfigInfoSelectElement.ins+ "_" + insConfigInfoSelectElement.id;
        var infoId = insConfigInfoSelectElement.id + "-" + insConfigInfoSelectElement.ins;
        html += '<section class="row" id="' + sectionRoleId + '" style="display: none">' +
            '<span class="title">' + insConfigInfoSelectElement.title + '</span>' +
            '<select id="' + infoId + '" class="field field-select">';
        var seleOption = insConfigInfoSelectElement.selectInfos;
        for (let j = 0; j < seleOption.length; j++) {
            var selectOptionElement = seleOption[j];
            html += '<option value="' + selectOptionElement.value + '">' + selectOptionElement.name + '</option>';
        }
        html += '</select>';
        if (insConfigInfoSelectElement.isTips) {
            html += '<span class="help-icon">?</span>' +
                '<div class="help-tooltip">' +
                '<span>' + insConfigInfoSelectElement.tipsText + '</span>';
            if (hasValue(insConfigInfoSelectElement.tipsImg)) {
                html += '<img src="' + insConfigInfoSelectElement.tipsImg + '">';
            }
            html += '</div>';
        }
        html += '</section>';
    }
    $("#" + addOldDomId).append(html);

    //添加完dom结构后看是否需要渲染相应的dom结构的默认值
    for (let i = 0; i < insConfigInfoInput.length; i++) {
        var insConfigInfoInputElement = insConfigInfoInput[i];
        if (isDefault){
            var info = JSON.parse(defaultInfo.vc2Extjson); var inputValue = info[insConfigInfoInputElement.id]
            // 判断是否为json数据
            try {
                if (typeof inputValue == "object") {
                    inputValue = JSON.stringify(inputValue)
                }
            } catch (e) {}
            $("#" + insConfigInfoInputElement.id + "-" + insConfigInfoInputElement.ins).val(inputValue)
        }
    }
    for (let i = 0; i < insConfigInfoSelect.length; i++) {
        var insConfigInfoSelectElement = insConfigInfoSelect[i];
        if (isDefault){
            var info = JSON.parse(defaultInfo.vc2Extjson);
            var selectId = document.getElementById(insConfigInfoSelectElement.id + "-" + insConfigInfoSelectElement.ins);
            selectId.value = info[insConfigInfoSelectElement.id];
            // $("#" + insConfigInfoSelectElement.id + "_" + insConfigInfoSelectElement.ins).val(info[insConfigInfoSelectElement.id])
        }
    }
}

function companyAccountUpdate(parse, numInsuranceId) {
    var vc2Extjson = {};
    //input输入框
    var insConfigInfoInput = parse.input;
    for (let i = 0; i < insConfigInfoInput.length; i++) {
        var insConfigInfoInputElement = insConfigInfoInput[i];
        //判断保司并进行相应的操作
        if (numInsuranceId == insConfigInfoInputElement.ins){
            //dom的id选择器名称
            var elementId = "#" + insConfigInfoInputElement.id + "-" + insConfigInfoInputElement.ins;
            //是否必填
            var isRequired = insConfigInfoInputElement.isRequired;
            if (isRequired && !hasValue($(elementId).val())){
                alert("请填写" + insConfigInfoInputElement.title);
                return;
            }
            if (hasValue($(elementId).val())) {
                vc2Extjson[insConfigInfoInputElement.id] = $(elementId).val();
            }
        }
    }
    //select输入框
    var insConfigInfoSelect = parse.select;
    for (let i = 0; i < insConfigInfoSelect.length; i++) {
        var insConfigInfoSelectElement = insConfigInfoSelect[i];
        //判断保司并进行相应的操作
        if (numInsuranceId == insConfigInfoSelectElement.ins){
            //dom的id选择器名称
            var elementId = "#" + insConfigInfoSelectElement.id + "-" + insConfigInfoSelectElement.ins;
            //是否必填
            var isRequired = insConfigInfoSelectElement.isRequired;
            if (isRequired && !hasValue($(elementId).val())){
                alert("请填写" + insConfigInfoSelectElement.title);
                return;
            }
            if (hasValue($(elementId).val())){
                vc2Extjson[insConfigInfoSelectElement.id] = $(elementId).val();
            }
        }
    }
    return vc2Extjson;

}
